<app-dialog-base>
  <span dialog-title>Issue Refund</span>
  <ng-container dialog-content>
    <div class="refund-reason">
      <p>Please specify the reason for issuing the refund.</p>
    </div>

    <form>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Refund Reason</mat-label>
        <mat-select [formControl]="reasonControl" data-testid="refund-reason-select">
          <mat-option data-testid="access-reason-option" *ngFor="let reason of validReasons" [value]="reason.value">
            {{reason.description}}
          </mat-option>
        </mat-select>
        <mat-error data-testid="access-reason-error-message"
                   *ngIf="(reasonControl.dirty || reasonControl.touched) && reasonControl.errors">
          Please select a reason for the refund
        </mat-error>
      </mat-form-field>
    </form>
  </ng-container>

  <ng-container actions>
    <button mat-button class="btn-success" [disabled]="!canContinue()" data-testid="submit-refund-button" (click)="submit()">Continue</button>
  </ng-container>
</app-dialog-base>
